export const combineQueryWithFragments = (...gqlQueries: string[]) => gqlQueries.join('');
